export default "https://assets.egbcdn.net/assets/packs/_/images/registration/registration_en-6b774b67da44ada90e989c66e869ecfe.jpg";